import { L1_VALUES, L3_PATHS } from 'Deer/constants/routes';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { useHistory } from 'react-router-dom';

export const useNavigateToGoalsClickThroughIndividualPage = () => {
  const { l1Module, teamType } = useRouteToNavLevels();
  const history = useHistory();
  const L1 = L1_VALUES[l1Module];
  const isTeamRoute = l1Module === 'team';

  const navigateToGoalsClickThroughIndividualPage = ({ name, employeeId }: { name: string; employeeId: string }) => {
    const queryParams = new URLSearchParams();
    queryParams.set('employeeId', employeeId);
    queryParams.set('employeeName', name);
    if (!isTeamRoute) {
      history.push({
        pathname: L3_PATHS[L1 as 'my-data' | 'company'].goal.individualsGoals,
        search: queryParams.toString(),
      });
    } else {
      history.push({
        pathname: L3_PATHS[L1 as 'team'][teamType].goal.individualsGoals,
        search: queryParams.toString(),
      });
    }
  };

  return { navigateToGoalsClickThroughIndividualPage };
};
